import React from "react";
import AdminChartSaveDialog from "../../../../../components/dialogs/admin-chart-save-dialog";
import { AdminManageNonPartisanChartState } from "../../hooks/use-admin-manage-non-partisan-chart";

const AdminManageNonPartisanChartControlButton: React.FC<{
	state: AdminManageNonPartisanChartState;
	errors: any;
}> = ({
	state: {
		form,
		saving,
		cancel,
		saveAndExit,
		openSaveAndContinueDialog,
		saveAndContinueDialog,
		closeSaveAndContinueDialog,
		saveAndContinue,
	},
	errors,
}) => {
		const disableButtons =
			!form.formState.isValid || form.formState.isSubmitting || saving;
		const isErrors = Object.keys(errors).length > 0 ? true : false;

		return (
			<>
				<div className="h-24 mb-8 bg-white">
					<div className="container flex items-center justify-end h-full gap-4 mx-auto">
						<button
							onClick={cancel}
							disabled={saving || form.formState.isSubmitting}
							className="uppercase border-b-2 border-primary-blue tracking-[0.07rem] justify-center items-center mr-6 text-primary-blue text-base font-semibold"
						>
							Cancel
						</button>
						<button
							onClick={saveAndExit}
							className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-primary-blue border border-primary-blue text-base font-semibold rounded-md shadow-sm bg-transparent hover:bg-primary-blue hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:cursor-not-allowed disabled:border-gray-500 disabled:text-gray-500 disabled:hover:bg-white"
						>
							Save & Exit
						</button>
						<button
							onClick={openSaveAndContinueDialog}
							className="uppercase tracking-[0.07rem] justify-center items-center px-6 py-3 text-white bg-primary-blue text-base font-semibold rounded-md shadow-sm hover:bg-white border hover:text-primary-blue hover:border-primary-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 disabled:cursor-not-allowed disabled:border-gray-500 disabled:text-gray-500 disabled:bg-white diabled:bg-transparent"
						>
							Save & Continue
						</button>
					</div>
				</div>
				<AdminChartSaveDialog
					isOpen={saveAndContinueDialog}
					toggle={closeSaveAndContinueDialog}
					onSave={saveAndContinue}
				/>
			</>
		);
	};

export default AdminManageNonPartisanChartControlButton;
